/**
 * @function stripCommas - Strips commas from a numstring
 * @param {string} str - num-string
 * @return {Array} - Array of characters
 * @example stripCommas(1,000) => ['1', '0', '0', '0']
 */
const stripCommas = str => str.split('').filter(char => char !== ',');

export default stripCommas;
